import { storeCreator } from '@/utils/store/store.utils';

interface State {
  isEditableTemplate: boolean;
  setIsEditableTemplate: (value: boolean) => void;
}

export const useStore = storeCreator<State>((set) => ({
  isEditableTemplate: false,
  setIsEditableTemplate: (value: boolean) => set(() => ({
    isEditableTemplate: value,
  })),
}));
export default useStore;
